
import { Box, SxProps, Typography, useTheme, styled, } from "@mui/material";
import { MiscSavio, StyleguideSavioColors, StyleguideSavioFonts } from "../../../configuration/themeSettings";
import { AppIconsArrow } from "../../../components/AppIcons";



export const MachineContainer = styled(Box, { label: "machine-container" })
    (({ theme }) => ({
        width: "100vw",

    }))


export const MachineContainerBom = styled(Box, { label: "machine-container-bom-main" })
    (({ theme }) => ({
        //height: "calc(100vh - 175px)",
        height: "calc(100% - 80px)",
        overflow: 'hidden',
    }))

export const MachineDetailBar = styled(Box, { label: "machine_detail-bar" })
    (({ theme }) => ({
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        borderRadius: 0,

        borderBottom: '1px solid ' + StyleguideSavioColors.lightGrey,
        "> div": {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            maxWidth: MiscSavio.maxWidthSite,
            margin: '0 auto',
        }

    }))

export const ButtonsContainer = styled(Box, { label: "machine_detail-button-container" })
    (({ theme }) => ({
        display: 'flex',
        alignItems: 'center',

        "a": {
            color: theme.palette.primary.main,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: 15,
            "&:hover": {
                color: StyleguideSavioColors.blue,
            },

            "&:last-child": {
                marginRight: 10,
            },
            "svg": {
                fontSize: 28,
            }
        },
    }))

export const MachineDetailTypography = styled(Typography, { label: "machine_detail-Typography" })
    (({ theme }) => ({
        display: "flex",
        alignItems: "center",
        fontWeight: StyleguideSavioFonts.bold,
        fontSize: 20,
        color: StyleguideSavioColors.text.grayTitles,
        padding: '7px 6px',

        "svg": {
            marginRight: 8,
            fontSize: 28,
            color: StyleguideSavioColors.grayBreadcrumb,
            "&:hover":{
                color: StyleguideSavioColors.grayBreadcrumb,
            }
        }
    }))

export const MachineContent = styled(Box, { label: "machine-content" })
    (({ theme }) => ({
        width: "100%",
        maxWidth: MiscSavio.maxWidthSite,
        margin: '0 auto',
        display: "flex",
        flexDirection: "row",
        height: "100%",

        ".MuiTableContainer-root": {
            paddingBottom: 0,
        },


        "thead tr": {
            ".MuiTableCell-root": {
                color: StyleguideSavioColors.mainBlue,
            },
            "&:hover .MuiTableCell-root": {
                backgroundColor: StyleguideSavioColors.lightestGrey + " !important",
            }
        },

        "tbody tr": {
            position: 'relative',


            "&:hover td.MuiTableCell-root": {
                


                "&:first-of-type": {
                    "&:before": {
                        display: 'block',
                        content: "''",
                        width: 3,
                        height: '100%',
                        backgroundColor: StyleguideSavioColors.blue,
                        left: 0,
                        position: 'absolute',


                    }

                },
                backgroundColor: 'inherit',
                "*": { textDecoration: 'underline',color: StyleguideSavioColors.blue, },

            }

        },
        ">main": {
            ">.MuiBox-root": {
                height: '100%',
            }
        }
    }))


export const Preview = styled("section", { label: "machine-preview" })
    (({ theme }) => ({
        display: 'flex',
        flexDirection: 'column',

    }))

export const HeaderPreview = styled(Box, { label: "machine-preview_header" })
    (({ theme }) => ({
        backgroundColor: theme.palette.primary.main,
        height: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.palette.common.white,
        cursor: 'pointer',
    }))

export const Icon = styled(AppIconsArrow, { label: "machine-preview_header_arrow" })
    (({ theme }) => ({
        fontSize: 15,
    }))

export const ContainerPreview = styled(Box, { label: "machine-preview_container" })
    (({ theme }) => ({
        backgroundColor: StyleguideSavioColors.lightestGrey,
        flex: 1,

        height: 'calc(100% - 15px) !important',

        "> div": { backgroundColor: '#fff', }
    }))


export const MachineDetailTree = styled(Box, { label: "machine_detail-tree" })
    (({ theme }) => ({

        width: "30%",
        minWidth: 260,
        overflow: "auto",
        textAlign: "left",
        backgroundColor: StyleguideSavioColors.footerGrey,

        "+ .MuiBox-root ": {
            paddingLeft: 15,
            height: '100%',

            ".MuiTableBody-root": {
                ".MuiTableRow-root": {
                    height: 60,

                    ".MuiTableCell-root:first-of-type": {
                        "svg": {
                            fontSize: 19,
                            marginTop: 5,
                        }
                    }
                }
            },


            '[role="presentation"]': {
                display: 'none',
            }
        }

    }))



export const useMachinePageClasses = (props: any) => {
    const theme = useTheme();
    const classes = {

        previewOpened:

            (props.showPanel) ? {
                "> div": {
                    height: props.up ? "50%" : "calc(100% - 16px)",
                },
                " > div > main": {
                    height: props.up ? "100%" : "calc(100% - 16px)",

                    "> div": {
                        height: '100% !important',
                    }
                },
                "table + div": { display: 'none', },
                "> section": {
                    height: props.up ? "50%" : "unset",
                    width: "100%",
                    maxWidth: MiscSavio.maxWidthSite,
                    margin: '0 auto',
                    "ul": {
                        //height: "calc(100vh - 29.8%)",
                    }
                }
            }
                : {
                    "> div ": {
                        height: "calc(100% - 16px)",
                    },
                    "> div  > main": {
                        height: "100%",
                    },
                    "table + div": { display: 'none', },
                    "> section": { height: "unset", width: "100%", maxWidth: MiscSavio.maxWidthSite, margin: '0 auto', }
                } as SxProps,

        //classe per il fullscreen della preview
        previewFullscreen: {
            width: '100%',
            maxWidth: MiscSavio.maxWidthSite, margin: '0 auto',
            "> div": {
                display: 'none',
            },
            "section": {
                height: "calc(100vh)",
            },
        } as SxProps,

    }

    return classes;
};
